var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJokeTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Joke_TV",
    "data-name": "Joke TV",
    transform: "translate(-2.198 -2.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9008",
    "data-name": "Path 9008",
    d: "M21.277,11.553A1.842,1.842,0,0,1,19.5,9.777,1.777,1.777,0,0,1,21.277,8",
    transform: "translate(-6.729 -2.039)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9009",
    "data-name": "Path 9009",
    d: "M9.5,8a1.842,1.842,0,0,1,1.777,1.777A1.777,1.777,0,0,1,9.5,11.553",
    transform: "translate(-2.651 -2.039)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4269",
    "data-name": "Rectangle 4269",
    width: 16,
    height: 16,
    rx: 4,
    transform: "translate(2.698 2.698)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9010",
    "data-name": "Path 9010",
    d: "M16.971,19H9a3.884,3.884,0,0,0,4.145,3.553A4.017,4.017,0,0,0,17.29,19",
    transform: "translate(-2.447 -6.525)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJokeTv);
export default __webpack_public_path__ + "static/media/Joke-TV.1007ce344eeaa040e8b789c5edf4788d.svg";
export { ForwardRef as ReactComponent };